module.exports = __webpack_public_path__ + "static/media/DARK.4dbc47f9.svg";